<template>
    <div class="text-center">
        <h2 class="ng-star-inserted">成长明星学员推荐</h2>
        <!--<div class="starts_card_div">-->
        <!--<StarsInfoCard class="path_card"></StarsInfoCard>-->
        <!--<StarsInfoCard class="path_card"></StarsInfoCard>-->
        <!--<StarsInfoCard class="path_card"></StarsInfoCard>-->
        <!--<StarsInfoCard class="path_card"></StarsInfoCard>-->
        <!--</div>-->
        <div class="starts_card_div" style="transform: translate3d(0px, 0px, 0px);"><!---->
            <a class="card" style="border: none;padding: 0;height: 270px" v-for="star in not_teacher_stars_info" :key="star.id" :href="'/user/'+star.user_info.id">
                <div class="com-2-activity-panel-object">
                    <div class="com-2-activity-panel-img"
                         style="background-image:url(http://localhost:8069/web/image?model=ujoyer.course.course&id=1&field=picture)"></div>
                    <time class="com-2-activity-panel-time">{{star.name}}</time>
                </div>
                <div class="com-2-activity-panel-main">
                    <div class="com-2-activity-panel-bd">
                        <p
                                class="com-2-activity-panel-pretitle without-order"><span
                                class="pretitle-inner"><div v-html="star.description"></div></span></p>
                        <h3 class="com-2-activity-panel-title" :title="star.wisdom">
                            {{star.wisdom}}</h3></div>
                </div>
            </a>
        </div>
        <h2 class="ng-star-inserted">与导师一同学习</h2>
        <div class="starts_card_div" style="transform: translate3d(0px, 0px, 0px);"><!---->
            <a class="card" v-for="star in teacher_stars_info" :key="star.id" :href="'/user/'+star.user_info.id">
                <img class="image" irdeferimage="" alt="" :src="star.cover_url">
                <h5 class="name">{{star.name}}</h5>
                <p class="title h6">{{star.honor}}</p><!---->
                <div class="bio x-small mb-0" v-html="star.description"></div>
                <!--<div class="bio x-small mb-0">-->

                    <!--<ul>-->
                        <!--<li>南京航空航天大学教授、研究生导师</li>-->
                        <!--<li>澳门科技大学兼职教授</li>-->
                        <!--<li>南京市秦淮区政协委员，智囊团成员</li>-->
                        <!--<li>江苏省“333跨世纪学术技术带头人”</li>-->
                        <!--<li>中国人类工效学学会理事</li>-->
                        <!--<li>……</li>-->
                    <!--</ul>-->
                    <!--<p>-->
                        <!--<span>研究领域</span>-->
                        <!--企业战略管理、流程优化、人力资源管理、工业工程、企业信息化建设等<br/>-->
                        <!--<span>出版著作</span>-->
                        <!--《企业战略管理》、《现代物流管理》、《股票期权理论与实务》、《基础工业工程》、《人因工程》等-->
                    <!--</p>-->
                <!--</div>-->
            </a>
            <!--<div class="card">-->
                <!--<img class="image" irdeferimage="" alt="" src="/static/img/head_qy.jpg">-->
                <!--<h5 class="name">钱焱</h5>-->
                <!--<p class="title h6">成长之路导师</p>&lt;!&ndash;&ndash;&gt;-->
                <!--<div class="bio x-small mb-0">-->
                    <!--<ul>-->
                        <!--<li>南京航空航天大学副教授、研究生导师</li>-->
                        <!--<li>南京大学企业管理博士</li>-->
                        <!--<li>南京佑佐首席培训师</li>-->
                        <!--<li>美国马里兰大学访问学者</li>-->
                        <!--<li>加拿大约克大学访问学者</li>-->
                        <!--<li>埃里克森ICF教练</li>-->
                        <!--<li>儿童心理游戏治疗认证讲师</li>-->
                    <!--</ul>-->
                    <!--<p>-->
                        <!--<span>专业方向</span>-->
                        <!--人力资源管理，尤其擅长心理学在人力资源管理中的应用。<br/>-->
                        <!--<span>出版编著</span>-->
                        <!--《人力资源管理》、《人力资源管理标准工作流程》、《薪酬管理》等-->
                    <!--</p>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="card">-->
                <!--<img class="image" irdeferimage="" alt="" src="/static/img/head_xhj.jpg">-->
                <!--<h5 class="name">徐洪江</h5>-->
                <!--<p class="title h6">成长之路导师</p>&lt;!&ndash;&ndash;&gt;-->
                <!--<div class="bio x-small mb-0">-->
                    <!--<ul>-->
                        <!--<li>南京大学管理学博士</li>-->
                        <!--<li>南京佑佐管理咨询有限公司副总裁</li>-->
                        <!--<li>南京佑佐信息资讯有限公司总经理</li>-->
                        <!--<li>国家职业资格培训专业培训师</li>-->
                        <!--<li>具备丰富的企业管理实战经验，先后在制造、贸易、汽车等行业企业中担任过技术员、经理、副总等高级管理职务</li>-->
                    <!--</ul>-->
                    <!--<p>-->
                        <!--<span>咨询领域</span>-->
                        <!--企业战略规划、组织结构发展、工业工程、流程再造、薪酬体系建设、人力资源规划等。<br/>-->
                    <!--</p>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="card">-->
                <!--<img class="image" irdeferimage="" alt="" src="/static/img/head_dg.jpg">-->
                <!--<h5 class="name">段光</h5>-->
                <!--<p class="title h6">成长之路导师</p>&lt;!&ndash;&ndash;&gt;-->
                <!--<div class="bio x-small mb-0">-->
                    <!--<ul>-->
                        <!--<li>南京大学管理学博士</li>-->
                        <!--<li>南京理工大学企业管理系主任</li>-->
                        <!--<li>充满活力的教育家，热爱社会工作，多年来一直置身于管理咨询、培训领域</li>-->
                        <!--<li>具备丰富的工作经验，成功辅导过数十家外企、合资企业、国企及民营企业的咨询项目</li>-->
                    <!--</ul>-->
                    <!--<p>-->
                        <!--<span>培训风格</span>-->
                        <!--独特的影响力在带给学员震撼的同时更带来对自身与团队的再思考，不断激发学员对于工作、生活的反思和持续不断的自身“价值”增值进步！-->
                    <!--</p>-->
                <!--</div>-->
            <!--</div>-->
        </div>
    </div>
</template>
<script type="text/javascript">
    import StarsInfoCard from '@/components/common_components/cards/stars_info_card.vue'
    import starApi from '@/api/star/star.js'
    import {mapState} from 'vuex'

    export default {
        components: {
            StarsInfoCard
        },
        data() {
            return {
                stars_info: []
            }
        },

        computed: {
            ...mapState({
                path_information: state => state.path.path_information
            }),
            not_teacher_stars_info: function () {
                let p = []
                for (var i = 0; i < this.stars_info.length; i++) {
                    if (!this.stars_info[i].is_teacher) {
                        p.push(this.stars_info[i])
                    }
                }
                return p
            },
            teacher_stars_info: function () {
                let p = []
                for (var i = 0; i < this.stars_info.length; i++) {
                    if (this.stars_info[i].is_teacher) {
                        p.push(this.stars_info[i])
                    }
                }
                return p
            },
        },
        mounted() {
            starApi.get_star_info().then((res) => {
                this.stars_info = res.data.stars_info
            })
        }
    }
</script>
<style type="text/css" scoped>
    .com-2-activity-panel-main {
        box-sizing: border-box;
        padding: 20px
    }

    .com-2-activity-panel-bd {
        min-height: 82px
    }

    .com-2-activity-panel-pretitle {
        margin-bottom: 10px;
        font-size: 14px;
        line-height: 24px;
        color: #666
    }

    .com-2-activity-panel-title {
        height: 48px;
        font-size: 18px;
        line-height: 24px;
        color: #000;
        font-weight: 400;
        display: block;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2
    }

    .com-2-activity-panel-pretitle em, .com-2-activity-panel-title em {
        color: #ff7200
    }

    .com-2-activity-panel-time {
        position: absolute;
        right: 10px;
        bottom: 10px;
        padding: 0 8px;
        height: 24px;
        background-color: rgba(0, 0, 0, .8);
        color: #fff;
        font-size: 14px;
        line-height: 24px
    }

    .com-2-activity-panel-object {
        position: relative;
        padding-top: 52.1052631579%;
        border-bottom: 1px solid #eee;
        overflow: hidden
    }

    .com-2-activity-panel-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat
    }

    .ng-star-inserted {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .card {
        height: 372px;
        width: 18rem;
        text-align: center;
        position: relative;
        display: inline-block;
        background-color: #fff;
        margin: 0 0.75rem 0 0;
        box-shadow: 5px 5px 25px 0px rgba(46, 61, 73, 0.2);
        border-radius: 0.375rem;
        padding: 0 24px 48px;
        float: left;
        margin-right: 0.75rem;
    }

    @media screen and (min-width: 48rem) {
        .card {
            height: 408px;
            margin: 0 0.75rem 24px 0;
        }
    }

    .card:nth-child(5n+1) {
        border-top: 3px solid #ffae0c;
    }

    .card:nth-child(5n+2) {
        border-top: 3px solid #ff5483;
    }

    .card:nth-child(5n+3) {
        border-top: 3px solid #02b3e4;
    }

    .card:nth-child(5n+4) {
        border-top: 3px solid #a951ed;
    }

    .card:nth-child(5n+5) {
        border-top: 3px solid #02ccba;
    }

    .image {
        height: 96px;
        width: 96px;
        margin-top: 0;
        margin-bottom: 6px;
        top: -0.75rem;
        display: block;
        margin: 0 auto;
        position: relative;
        border-radius: 50%;
        box-shadow: 8px 10px 20px 0px rgba(46, 61, 73, 0.15);
    }

    .name {
        margin-top: 0;
        margin-bottom: 0px;
        color: #2e3d49;
    }

    .title {
        margin: 2px;
        color: #7d97ad;
        min-height: 1em;
    }

    .bio.x-small {
        height: 240px;
        width: 100%;
        overflow: hidden;
        display: inline-block;
        line-height: 1.25rem;
        color: #555;
    }

    .bio >>> ul, >>> li {
        text-align: left;
        list-style: circle;
        margin-left: 9px;
    }

    .bio p {
        text-align: left;
    }

    .bio p span {
        font-weight: bold;
    }

    .x-small p {
        font-size: 0.8125rem;
        line-height: 24px;
    }

    .starts_card_top {
        width: 9999em;
    }

    .starts_card_div {
        display: flex;
        flex-wrap: wrap;
        width: 1200px;
        margin-left: auto;
        margin-right: auto;
    }

    .path_card {
        width: 25%;
    }
</style>
